export const easing = {
  ease_1: [0.13, 1.0, 0.34, 1.0],
};
